import './index.css';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { LoaderOutlinedSize16, LoaderOutlinedSize24, LoaderOutlinedSize64, LoaderOutlinedSize96 } from '@hh.ru/magritte-ui-icon/icon';

var styles = {"loader":"magritte-loader___GSe1a_1-3-25","spin":"magritte-spin___DyLX-_1-3-25","internal_overriden":"magritte-internal_overriden___GcH9X_1-3-25","internalOverriden":"magritte-internal_overriden___GcH9X_1-3-25"};

const iconsBySize = new Map([
    [16, LoaderOutlinedSize16],
    [24, LoaderOutlinedSize24],
    [64, LoaderOutlinedSize64],
    [96, LoaderOutlinedSize96],
]);
const Loader = ({ size = 16, 'aria-label': ariaLabel = 'loading', initial, ...props }) => {
    const Element = iconsBySize.get(size);
    if (!Element) {
        return null;
    }
    const baseProps = {
        'aria-label': ariaLabel,
        initialColor: initial,
        ...props,
    };
    return (jsx("span", { className: classNames(styles.loader, {
            [styles.internal_overriden]: !initial,
        }), role: "status", "data-qa": "magritte-loader", children: jsx(Element, { ...baseProps }) }));
};

export { Loader };
//# sourceMappingURL=Loader.js.map
